var React = require('react');

function SearchMagnifyGlass (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.00039 14.3998C4.00039 8.65614 8.65676 3.9999 14.4007 3.9999C20.1447 3.9999 24.8011 8.65614 24.8011 14.3998C24.8011 20.1435 20.1447 24.7998 14.4007 24.7998C8.65676 24.7998 4.00039 20.1435 4.00039 14.3998ZM14.4007 2.3999C7.77315 2.3999 2.40039 7.77243 2.40039 14.3998C2.40039 21.0273 7.77315 26.3998 14.4007 26.3998C17.4264 26.3998 20.1906 25.28 22.3014 23.4323L28.2347 29.3656C28.5471 29.678 29.0537 29.678 29.3661 29.3656C29.6785 29.0532 29.6785 28.5466 29.3661 28.2342L23.4329 22.301C25.281 20.1902 26.4011 17.4258 26.4011 14.3998C26.4011 7.77243 21.0283 2.3999 14.4007 2.3999Z","fill":"#005752"}));
}

SearchMagnifyGlass.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = SearchMagnifyGlass;

SearchMagnifyGlass.default = SearchMagnifyGlass;
